export default "__VITE_ASSET__nrpxQ7sT__"